import React from 'react';
import { withRouter } from 'react-router-dom';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import AddSiteForm from '../../components/Site/AddSiteForm';

const AddSitePage = props =>
  <LargePaper>
    <h1 style={stylesDefault.title}>Ajouter un site</h1>
    <AddSiteForm history={props.history}/>
  </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(AddSitePage));



// WEBPACK FOOTER //
// ./src/containers/SitesPage/AddSitePage.jsx